<ng-container *ngIf="detailAppel">
    <!-- <div style="margin: 10px;">
        <a routerLink="/calls">Retour à la liste des appels</a>
    </div> -->
    <div class="shadowed">
        <div class="row">
            <div class="col-3">
                <h5>Intervenants Adial</h5>
                <!-- <a routerLink="/person">&nbsp;</a> -->
                <ng-container *ngFor=" let intervenant of detailAppel.intervenants">
                    <p>{{intervenant.intervenant}}</p>
                </ng-container>
            </div>
            <div class="col-3">
                <button class="btn btn-outline-dark" (click)="modifyCall()">Modifier</button>
            </div>
            <div class="col-6">
                <h5>Validation du rapport</h5>
                <p *ngIf="callGmao">
                    Rapport
                    <ng-container *ngIf="callGmao.call_state"><strong class="ok">OK</strong></ng-container>
                    <ng-container *ngIf="!callGmao.call_state"><strong class="nok">NOK</strong></ng-container>
                    par <b>{{callGmao.user_login}}</b> le {{getNiceDate(callGmao.state_time)}}
                </p>
                <div class="ok-nok" *ngIf="!callGmao || !callGmao.call_state">
                    <button class="btn btn-success" (click)="submitValidation(true)">Rapport OK</button>
                    <button class="btn btn-danger" (click)="submitValidation(false)">Rapport NOK</button>
                </div>
            </div>
        </div>

    </div>
    <div class="shadowed">
        <h5>Identification de l'appel</h5>
        <div class="row">
            <a [routerLink]="['/installation', detailAppel.id_installation]" class="col-sm-2">Installation</a>
            <p class="col-8">{{ detailAppel.nom_installation }}</p>
            <p class="w-100"></p>
            <!-- <a routerLink="/person" class="col-sm-2">Interlocuteur</a> -->
            <a class="col-sm-2" style="text-decoration: none; color: black;">Interlocuteur</a>
            <ng-container *ngIf="name">
                <p class="col-8"> {{ name.prenom }} {{ name.nom }}</p>
            </ng-container>
            <br>
            <p class="w-100" style="margin-left: 15px;" *ngIf="detailAppel.societe_facturee">La société facturée est
                <span> {{
                    detailAppel.societe_facturee.raison_sociale }} ( {{ detailAppel.societe_facturee.code_ebp }}
                    )</span>
            </p>
            <ng-container *ngIf="contrat">
                <p class="w-100">Contrat SAV de l'installation : <span
                        [className]="contrat.id_contrat_sav > 0 ? 'ok' : 'nok' ">{{ contrat.nom_contrat }}</span>
                </p>
            </ng-container>
        </div>
    </div>
    <div class="shadowed">
        <h5>Facturation</h5>
        <div class="row">
            <div class="col-md-7 col-12">
                <p> <span>Date d'appel : </span>{{ getNiceDate(detailAppel.date_debut) }}</p>
                <p> <span> Durée de l'appel : </span>{{ detailAppel.duree }} minutes</p>
                <ng-container *ngIf="detailAppel.termine==1">
                    <p>Terminé</p>
                </ng-container>
                <ng-container *ngIf="detailAppel.termine==0">
                    <p>En cours</p>
                </ng-container>
                <ng-container *ngIf="detailAppel.facturable==0">
                    <p>Non facturable</p>
                </ng-container>
                <ng-container *ngIf="detailAppel.facturable==1">
                    <p>facturable</p>
                </ng-container>
            </div>
            <div class="col-md-5 col-12">
                <p> <span>Numéro de facture : </span>{{detailAppel.numero_facture}}</p>
                <p> <span>Commentaire : </span>{{detailAppel.commentaires_facturation}} </p>
            </div>
            
        </div>
    </div>
    <div class="shadowed">
        <h5>Détails de l'appel</h5>
        <div class="row shadowed" *ngFor="let action of detailAppel.actions">
            <ng-container *ngIf="action.id_mat_unite==0">
                <p class="offset-sm-2 col-sm-10">L'action n'est associée à aucun matériel</p>
            </ng-container>
            <ng-container *ngIf="action.id_mat_unite !=0">
                <p class="offset-sm-2 col-sm-10">L'action est associée au matériel : {{
                    action.mat_classe }}</p>
            </ng-container>
            <p class="col-sm-2">Titre : </p>
            <p class="col-sm-10">{{ action.nom_action }}</p>
            <p class="col-sm-2">Description : </p>
            <p class="col-sm-10"> {{ action.descriptif }}</p>
            <div class="form-check col-sm-10">
                <input type="checkbox" class="form-check-input" id="aprevoir" name="aprevoir" disabled
                    [checked]="action.deplacement_to_do">
                <label for="aprevoir" class="form-check-label">Intervention à prévoir</label>
            </div>
            <div class="form-check col-sm-10">
                <input type="checkbox" class="form-check-input" id="effectue" name="effectue" disabled
                    [checked]="action.deplacement_done">
                <label for="effectue" class="form-check-label">Intervention sur place effectuée</label>
            </div>
        </div>
        <!--  -->
    </div>

</ng-container>